export class dateFormaOptions {
  
  simple = dateFormaOptionsSimple.none;
  addDay = 0;
  addMonth = 0;
  addYear = 0;
  setTimeSpan = ''
}

export const dateFormaOptionsSimple = {
  'none':0,
  'dayStart':1,
  'dayEnd':2,
  'monthStart':16,
  'monthEnd':32,
  'seasonStart':64,
  'seasonEnd':128,
  'yearStart':256,
  'yeasEnd':512,
  'weekStart':1024,
  'weekEnd':2048
}

const dateFormat = function (dateParams, fmt,options = new dateFormaOptions()) {

  let date = new Date()
  if(dateParams){
    if(typeof(dateParams) == "string"){
      date = new Date(dateParams)
    }else{
      date = dateParams
    }
  }
  if (options != null) {
    switch(options.simple){
      case dateFormaOptionsSimple.dayStart:
        {
          date = new Date(date.getFullYear(), date.getMonth(), date.getDate())
          date.setHours(0, 0, 0, 0)
        }
      break;
      case dateFormaOptionsSimple.dayEnd:
        {
          date = new Date(date.getFullYear(), date.getMonth(), date.getDate())
          date.setHours(23, 59, 59, 999)
        }
      break;
      case dateFormaOptionsSimple.monthStart:
        {
          date = new Date(date.getFullYear(), date.getMonth(), 1)
          date.setHours(0, 0, 0, 0)
        }
      break;
      case dateFormaOptionsSimple.monthEnd:
        {
          date = new Date(date.getFullYear(), date.getMonth() + 1, 0)
          date.setHours(23, 59, 59, 999)
        }
      break;
      case dateFormaOptionsSimple.seasonStart:
        {
          let m = date.getMonth() + 1
          m = Math.ceil(m / 3)
          date = new Date(date.getFullYear(), (m - 1) * 3, 1)
          date.setHours(0, 0, 0, 0)
        }
      break;
      case dateFormaOptionsSimple.seasonEnd:
        {
          let m = date.getMonth() + 1
          m = Math.ceil(m / 3)
          date = new Date(date.getFullYear(), (m * 3 - 1), 31)
          date.setHours(23, 59, 59, 999)
        }
      break;
      case dateFormaOptionsSimple.yearStart:
        {
          date = new Date(date.getFullYear(), 0, 1)
          date.setHours(0, 0, 0, 0)
        }
      break;
      case dateFormaOptionsSimple.yeasEnd:
        {
          date = new Date(date.getFullYear(), 11, 31)
          date.setHours(23, 59, 59, 999)
        }
      break;
      case dateFormaOptionsSimple.weekStart:
        {
          const today = new Date();
          const day = today.getDay(); // 获取当前是星期几（0-6）
          // 计算与本周第一天的天数差
          const diff = (day - 1 + 7) % 7;
          // 设置本周第一天（时间设为00:00:00.000）
          const firstDay = new Date(today);
          firstDay.setDate(today.getDate() - diff);
          firstDay.setHours(0, 0, 0, 0);
          date = firstDay
        }
        break;
      case dateFormaOptionsSimple.weekEnd:
        {
          const today = new Date();
          const day = today.getDay(); // 获取当前是星期几（0-6）
          // 计算与本周第一天的天数差
          const diff = (day - 1 + 7) % 7;
          // 设置本周第一天（时间设为00:00:00.000）
          const firstDay = new Date(today);
          firstDay.setDate(today.getDate() - diff);
          firstDay.setHours(0, 0, 0, 0);
          // 设置本周最后一天（时间设为23:59:59.999）
          const lastDay = new Date(firstDay);
          lastDay.setDate(firstDay.getDate() + 6);
          lastDay.setHours(23, 59, 59, 999);
          date = lastDay
        }
        break;
    }
    if (options.addDay) {
      date.setDate(date.getDate() + options.addDay)
    }
    if (options.addMonth) {
      date.setMonth(date.getMonth() + 1 + options.addMonth)
    }
    if (options.addYear) {
      date.setFullYear(date.getFullYear() + options.addYear)
    }
    if(options.setTimeSpan){
      let [hours, minutes, seconds] = options.setTimeSpan.split(':').map(Number)
      if(!hours){
        hours = 0
      }
      if(!minutes){
        minutes = 0
      }
      if(!seconds){
        seconds = 0
      }
      date.setHours(hours,minutes,seconds)
    }
}
  if (!fmt) {
      fmt = 'yyyy-MM-dd HH:mm:ss'
  }
  var o = {
      "M+": date.getMonth() + 1, //月份   
      "d+": date.getDate(), //日   
      "H+": date.getHours(), //小时   
      "m+": date.getMinutes(), //分   
      "s+": date.getSeconds() //秒    
  };
  if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

const getMonthLastDay = function(date){
  let now = new Date();
  if(typeof date == "object"){
    now = date
  }
  let year = now.getFullYear();
  let month = now.getMonth() + 1;
  return daysInMonth = new Date(year, month, 0).getDate();
}

const dateDayDiff = function(time1, time2) {
	let date1 = new Date()
	let date2 = new Date()
	if (typeof time1 == 'string') {
		time1 = time1.replace(/-|\./g, '/')
		date1 = new Date(time1)
	} else if (typeof time1 == "object") {
		date1 = time1
	}
	if (typeof time2 == 'string') {
		time2 = time2.replace(/-|\./g, '/')
		date2 = new Date(time2)
	} else if (typeof time2 == "object") {
		date2 = time2
	}
	return parseInt(((date2 - date1) / 86400000).toFixed())
}

const randomString = function (length = 10) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }
  return result;
}

const getKVList = function(list,key){
  if(list && list.length){
    let temp = list.find(t => t.Key == key)
    if(temp && temp.Value){
      return temp.Value
    }
  }
  return []
}

const arrayIV = function(list,index, defaultValue = null){
  if(list.length - 1 < index){
    return defaultValue
  }
  if(list[index]){
    return list[index]
  }
  return defaultValue
}

const deepCopy = function(obj, cache = new WeakMap()) {
  if (obj === null || typeof obj !== 'object') {
      return obj;
  }
  if (cache.has(obj)) {
      return cache.get(obj);
  }
  const copy = Array.isArray(obj) ? [] : {};
  cache.set(obj, copy);
  for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
          copy[key] = deepCopy(obj[key], cache);
      }
  }
  return copy;
}

const getUrlParams = function(url,key){
  return decodeURIComponent((new RegExp('[?|&]' + key + '=' + '([^&;]+?)(&|#|;|$)','i').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

const getEnglishChar = function(index) {
  let charStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
  let base = charStr.length
  let result = ""
  index += 1
  while (index > 0) {
    index -= 1
    result = charStr[index % base] + result
    index = Math.floor(index / base)
  }
  return result
}

const textCopy = async function(data){
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(data);
    } catch (err) {
      console.error("使用 navigator.clipboard 复制失败:", err);
      fallbackCopyText(data)
    }
  } else {
    fallbackCopyText(data)
  }
  function fallbackCopyText(data){
    const textarea = document.createElement("textarea");
    textarea.value = data;
    textarea.style.position = "fixed";
    textarea.style.top = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("使用 execCommand 复制失败:", err);
    }
    document.body.removeChild(textarea);
  }
}

export default {
  textCopy,
  getEnglishChar,
  dateDayDiff,
  getMonthLastDay,
  getUrlParams,
  deepCopy,
  arrayIV,
  getKVList,
  dateFormat,
  randomString
}


// WEBPACK FOOTER //
// ./src/libs/utils.js